import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Event from "@/pages/Event";
import Admin from "@/pages/Admin";
import useLenis from "@/lib/useLenis";

function Shell({ children }) {
  useLenis();
  useEffect(() => {
    const links = [
      { href: "https://fonts.googleapis.com", rel: "preconnect" },
      { href: "https://fonts.gstatic.com", rel: "preconnect", crossOrigin: "anonymous" },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,400;1,9..144,300;1,9..144,400&family=Sora:wght@300;400;500;600;700&display=swap",
      },
    ];
    const nodes = links.map((attrs) => {
      const l = document.createElement("link");
      Object.entries(attrs).forEach(([k, v]) => l.setAttribute(k, v));
      document.head.appendChild(l);
      return l;
    });
    return () => nodes.forEach((n) => n.remove());
  }, []);
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell>
          <Toaster
            position="bottom-right"
            theme="light"
            toastOptions={{
              style: {
                background: "#FFFFFF",
                color: "#17120E",
                border: "1px solid #E7E1D8",
                fontFamily: "Sora, sans-serif",
                fontSize: "13px",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/event" element={<Event />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Shell>
      </BrowserRouter>
    </div>
  );
}
